import { useIntl } from "react-intl";

import {
  AssetRequestType,
  AssetStatus,
} from "../../../../../../v1/components/pages/GameDetail/components/AssetsTab/utils/constants";
import { useRequestsStore } from "../../../../../store/useRequestsStore/useRequestsStore";

import "./requestsInfo.scss";

export const RequestsInfo = () => {
  const intl = useIntl();
  const queue = useRequestsStore(state => state.queue);

  const getRequestsInfo = (requestType: AssetRequestType) => {
    const totalRequests = queue.filter(
      asset => asset.requestType === requestType && !asset.isFolder,
    );

    if (totalRequests.length === 0) return;

    const succesRequests = totalRequests.filter(
      asset => asset.status === AssetStatus.SUCCESS && !asset.isFolder,
    );

    return intl.formatMessage(
      {
        id:
          requestType === AssetRequestType.UPLOAD
            ? "label.upload-information"
            : "label.download-information",
      },
      {
        totalSucces: succesRequests.length,
        totalRequests: totalRequests.length,
      },
    );
  };

  return (
    <section className="requests-info">
      <span>{getRequestsInfo(AssetRequestType.UPLOAD)}</span>
      <span>{getRequestsInfo(AssetRequestType.DOWNLOAD)}</span>
    </section>
  );
};
